export default anonPaymentSummaryCtrl

/** @ngInject */
function anonPaymentSummaryCtrl($scope, $window, $stateParams, AnonPayment, ContactTelephone, ErrorCatcher, paymentToken) {
    $scope.contactTelephone = ContactTelephone
    $scope.token = paymentToken
    $scope.isLoading = false
    $scope.error = null

    $scope.goToPayment = () => {
        $scope.isLoading = true
        $scope.error = null
        AnonPayment.getRedirect({ tokenId: $stateParams.tokenId }).$promise.then((redirectResult) => {
            $window.location = redirectResult.redirectUrl
        }).catch((error) => {
            ErrorCatcher.catchError(error)
            $scope.isLoading = false
            $scope.error = error
        })
    }
}



// WEBPACK FOOTER //
// ./src/states/anonPaymentSummary/anonPaymentSummary.js